/**
 * UserMenu - User icon and authentication actions
 */
import { User } from 'lucide-react';

export const UserMenu = ({ isAuthenticated, user, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="p-2 hover:bg-site-bg-dark hover:text-white transition-colors relative"
      data-testid="user-btn"
    >
      {isAuthenticated && user?.picture ? (
        <img 
          src={user.picture} 
          alt={user.name}
          className="w-5 h-5 rounded-full"
        />
      ) : (
        <User className="w-5 h-5" />
      )}
    </button>
  );
};

export default UserMenu;
